module.exports = __webpack_public_path__ + "static/img/15.c87bbb88.png";